module.exports = __webpack_public_path__ + "img/slide3.6d1975c6.jpg";